import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { useState } from 'react';
import Icon from '../Icon/Icon.js';
import { PictureReplacement, Picture as Picture$2 } from './style.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { DOCUMENT_MEDIA_CAMERA_PHOTO_UNAVAILABLE } from '../IconPath/DOCUMENT_MEDIA_CAMERA_PHOTO_UNAVAILABLE.js';

var _excluded = ["sources", "className", "errorIcon", "lazy", "alt"],
    _excluded2 = ["srcSet", "type", "media"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var defaultErrorIcon = {
  path: DOCUMENT_MEDIA_CAMERA_PHOTO_UNAVAILABLE,
  size: 'xl',
  sizeMobile: 'l'
};

var Picture = function Picture(_ref) {
  var _sources;

  var sources = _ref.sources,
      className = _ref.className,
      errorIcon = _ref.errorIcon,
      lazy = _ref.lazy,
      alt = _ref.alt,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState({
    hasBrokenImageUrl: false
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  if (!sources || sources.length <= 0) {
    return false;
  }

  var src = (_sources = sources[sources.length - 1]) === null || _sources === void 0 ? void 0 : _sources.srcSet;

  var onErrorCallback = function onErrorCallback() {
    setState({
      hasBrokenImageUrl: true
    });
  };

  if (state.hasBrokenImageUrl) {
    return /*#__PURE__*/jsx(PictureReplacement, {
      className: className,
      children: /*#__PURE__*/jsx(Icon, {
        className: "sg-picture-icon",
        path: (errorIcon === null || errorIcon === void 0 ? void 0 : errorIcon.path) || defaultErrorIcon.path,
        size: (errorIcon === null || errorIcon === void 0 ? void 0 : errorIcon.size) || defaultErrorIcon.size,
        sizeMobile: (errorIcon === null || errorIcon === void 0 ? void 0 : errorIcon.sizeMobile) || defaultErrorIcon.sizeMobile
      })
    });
  }

  return /*#__PURE__*/jsxs(Picture$2, {
    className: className,
    children: [sources.map(function (_ref2, index) {
      var srcSet = _ref2.srcSet,
          type = _ref2.type,
          media = _ref2.media,
          sourceRest = _objectWithoutProperties(_ref2, _excluded2);

      return /*#__PURE__*/jsx("source", _objectSpread({
        type: type,
        media: media,
        srcSet: srcSet
      }, sourceRest), index);
    }), /*#__PURE__*/jsx("img", _objectSpread({
      alt: alt || null,
      role: alt ? null : 'presentation',
      onError: onErrorCallback,
      loading: lazy ? 'lazy' : 'eager',
      src: src
    }, rest))]
  });
};

Picture.defaultProps = {
  className: null,
  errorIcon: defaultErrorIcon,
  lazy: false,
  alt: null
};
var Picture$1 = Picture;

export { Picture$1 as default };
//# sourceMappingURL=Picture.js.map
